import { render, staticRenderFns } from "./password.vue?vue&type=template&id=0edf443f&scoped=true"
import script from "./password.vue?vue&type=script&lang=js"
export * from "./password.vue?vue&type=script&lang=js"
import style0 from "./password.vue?vue&type=style&index=0&id=0edf443f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0edf443f",
  null
  
)

export default component.exports